import iphoneImage from 'assets/images/iphone.png';
import analyticsImage from 'assets/images/features/analytics.png';
import brandedAppImage from 'assets/images/features/branded-app.jpg';
import liveCollaborationImage from 'assets/images/features/live-collaboration.jpg';
import onlineImage from 'assets/images/features/online.jpg';
import scheduleImage from 'assets/images/features/schedule.jpg';

const purpleStripeSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4428.76 572.34"><defs><linearGradient id="purpleStripe" x1="-145.43" y1="545.7" x2="5305.56" y2="545.7" gradientTransform="matrix(1.18, 0.07, -0.12, 1.04, -728.09, -467.03)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff" /><stop offset="0.26" stop-color="#e8e1fe" /><stop offset="0.63" stop-color="#c1b0fc" /></linearGradient></defs><polygon fill="url(#purpleStripe)" points="4428.11 0.53 119.19 191.97 0.69 571.8 4343.85 341.7 4428.11 0.53" /></svg>';

const blueStripeSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4200 700"><defs><linearGradient id="blueStripeGradient" x1="-275.58" y1="506.03" x2="6866.14" y2="506.03" gradientTransform="matrix(2.23, -0.09, 0.03, 1.08, -2735.91, 81.64)" gradientUnits="userSpaceOnUse"><stop offset="0.26" stop-color="#b5e4fc" /><stop offset="0.92" stop-color="#1ad3ff" /></linearGradient></defs><polygon fill="url(#blueStripeGradient)" points="4200 0 0.53 442.51 12.7 700 4100 700 4200 0" /></svg>';

const greenStripeSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4414.17 906.12"><defs><linearGradient id="greenStripeGradient" x1="-2204.75" y1="453.06" x2="8586" y2="453.06" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fff" /><stop offset="0.57" stop-color="#52e4a8" /></linearGradient></defs><polygon fill="url(#greenStripeGradient)" points="4414.17 0 186.29 590.81 0 904.48 4121.34 906.12 4414.17 0" /></svg>';

const footerStripeSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4200 700"><defs><linearGradient id="footerStripeGradient" x1="-1488.81" y1="600.29" x2="4200.22" y2="600.78" gradientTransform="matrix(1.04, -0.25, 0.25, 1.04, -177.83, 525.68)" gradientUnits="userSpaceOnUse"><stop offset="0.42" stop-color="#b5e4fc" /><stop offset="0.92" stop-color="#1ad3ff" /></linearGradient></defs><polygon fill="url(#footerStripeGradient)" points="1460,700 4200,0 4200,700" /></svg>';

export default theme => ({
  // Main section
  mainSection: {
    position: 'relative',
    paddingTop: theme.spacing.unit * 5,
    [theme.breakpoints.up('lg')]: {
      width: 1160,
      margin: 'auto',
      display: 'flex',
      justifyContent: 'space-around',
    }
  },
  mainSectionContainer: {
    [theme.breakpoints.up('lg')]: {
      width: 'auto',
      margin: 0
    }
  },
  mainSectionText: {
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing.unit * 10
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing.unit * 5
    },
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'pre-wrap'
    }
  },
  mainSectionTextTitle: {
    font: '300 42px/50px "Open Sans"',
    marginBottom: theme.spacing.unit * 2
  },
  mainSectionTextDescription: {
    font: '300 17px/21px "Open Sans"'
  },
  mainSectionIphone: {
    overflow: 'hidden'
  },
  mainSectionIphoneInner: {
    position: 'relative',
    width: 304,
    height: 599,
    margin: 'auto',
    background: {
      image: `url("${iphoneImage}")`,
      size: 'cover'
    },
    '& > video': {
      borderRadius: 2,
      width: 250,
      height: 445,
      position: 'absolute',
      top: 73,
      left: 29
    }
  },
  // Purple stripe
  purpleStripe: {
    background: {
      image: `url('data:image/svg+xml;utf8,${encodeURIComponent(purpleStripeSvg)}')`,
      position: 'center center',
      size: 'cover'
    },
    marginTop: -120,
    padding: '180px 0'
  },
  purpleStripeContainer: {
    extend: 'mainSectionContainer'
  },
  purpleStripeText: {
    [theme.breakpoints.up('lg')]: {
      width: 600,
      margin: 'auto',
      textAlign: 'center',
    }
  },
  purpleStripeTextTitle: {
    font: '300 30px/35px "Open Sans"',
    color: '#fff',
    marginBottom: theme.spacing.unit * 2
  },
  purpleStripeTextDescription: {
    font: '300 21px/24px "Open Sans"',
    color: '#fff',
    marginBottom: theme.spacing.unit * 5
  },
  purpleStripeTextButton: {
    backgroundColor: 'transparent',
    border: '2px solid #fff',
    borderRadius: 2,
    color: '#fff',
    display: 'inline-block',
    height: 36,
    lineHeight: '32px',
    padding: `0 ${theme.spacing.unit * 2}px`,
    textTransform: 'uppercase',
    transitionProperty: 'border-color, background-color',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeIn,
    '&:hover': {
      backgroundColor: theme.palette.primary['500'],
      borderColor: 'transparent'
    }
  },
  // Dashboard
  dashboard: {
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      width: 1160,
      margin: 'auto',
      display: 'flex',
      justifyContent: 'space-around',
      flexDirection: 'row-reverse',
    }
  },
  dashboardContainer: {
    extend: 'mainSectionContainer'
  },
  dashboardText: {
    [theme.breakpoints.up('lg')]: {
      width: 400
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing.unit * 5
    }
  },
  dashboardTextTitle: {
    font: '300 30px/35px "Open Sans"',
    marginBottom: theme.spacing.unit * 2
  },
  dashboardTextDescription: {
    font: '300 17px/21px "Open Sans"'
  },
  dashboardImage: {
    position: 'relative',
    zIndex: -1,
    overflow: 'hidden'
  },
  dashboardImageInner: {
    width: 601,
    height: 435,
    margin: 'auto',
    background: {
      image: `url(${scheduleImage})`,
      size: 'cover'
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing.unit * 10
    }
  },
  // Blue stripe
  blueStripe: {
    background: {
      image: `url('data:image/svg+xml;utf8,${encodeURIComponent(blueStripeSvg)}')`,
      size: 'cover'
    },
    // "Magic" positioning
    marginTop: -250,
    paddingTop: 300,
    [theme.breakpoints.up('lg')]: {
      backgroundPosition: 'center bottom'
    },
    [theme.breakpoints.down('lg')]: {
      backgroundPosition: '60% bottom'
    }
  },
  blueStripeInner: {
    [theme.breakpoints.up('lg')]: {
      width: 1160,
      margin: 'auto',
      display: 'flex',
      justifyContent: 'space-around',
      flexDirection: 'row-reverse',
    }
  },
  blueStripeContainer: {
    extend: 'mainSectionContainer'
  },
  blueStripeText: {
    [theme.breakpoints.up('lg')]: {
      width: 400,
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing.unit * 5
    }
  },
  blueStripeTextTitle: {
    font: '300 30px/35px "Open Sans"',
    color: '#fff',
    marginBottom: theme.spacing.unit * 2
  },
  blueStripeTextDescription: {
    font: '300 17px/21px "Open Sans"',
    color: '#fff'
  },
  blueStripeImage: {
    overflow: 'hidden'
  },
  blueStripeImageInner: {
    width: 601,
    height: 330,
    margin: 'auto',
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    background: {
      image: `url(${liveCollaborationImage})`,
      size: 'cover'
    }
  },
  // Online now
  onlineNow: {
    position: 'relative',
    paddingTop: theme.spacing.unit * 14,
    [theme.breakpoints.up('lg')]: {
      width: 1160,
      margin: 'auto',
      display: 'flex',
      justifyContent: 'space-around',
    }
  },
  onlineNowContainer: {
    extend: 'mainSectionContainer'
  },
  onlineNowText: {
    [theme.breakpoints.up('lg')]: {
      width: 400,
      whiteSpace: 'pre-wrap'
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing.unit * 5
    }
  },
  onlineNowTextTitle: {
    font: '300 30px/35px "Open Sans"',
    marginBottom: theme.spacing.unit * 2
  },
  onlineNowTextDescription: {
    font: '300 17px/21px "Open Sans"'
  },
  onlineNowImage: {
    position: 'relative',
    zIndex: -1,
    overflow: 'hidden'
  },
  onlineNowImageInner: {
    width: 601,
    height: 331,
    margin: 'auto',
    background: {
      image: `url(${onlineImage})`,
      size: 'cover'
    }
  },
  // Green stripe
  greenStripe: {
    background: {
      image: `url('data:image/svg+xml;utf8,${encodeURIComponent(greenStripeSvg)}')`,
      size: 'cover'
    },
    // "Magic" positioning
    marginTop: -300,
    padding: '370px 0 20px',
    [theme.breakpoints.up('lg')]: {
      backgroundPosition: 'center center'
    },
    [theme.breakpoints.down('lg')]: {
      backgroundPosition: '70% center'
    }
  },
  greenStripeContainer: {
    extend: 'mainSectionContainer'
  },
  greenStripeInner: {
    [theme.breakpoints.up('lg')]: {
      width: 1160,
      margin: 'auto',
      display: 'flex',
      justifyContent: 'space-around',
      flexDirection: 'row-reverse'
    }
  },
  greenStripeText: {
    [theme.breakpoints.up('lg')]: {
      width: 400,
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing.unit * 5
    }
  },
  greenStripeTextTitle: {
    font: '300 30px/35px "Open Sans"',
    color: '#fff',
    marginBottom: theme.spacing.unit * 2
  },
  greenStripeTextDescription: {
    font: '300 17px/21px "Open Sans"',
    color: '#fff'
  },
  greenStripeImage: {
    overflow: 'hidden'
  },
  greenStripeImageInner: {
    width: 600,
    height: 443,
    margin: 'auto',
    background: {
      image: `url(${analyticsImage})`,
      size: 'cover'
    }
  },
  // Custom app
  customApp: {
    position: 'relative',
    paddingTop: theme.spacing.unit * 10,
    [theme.breakpoints.up('lg')]: {
      width: 1160,
      margin: 'auto',
      display: 'flex',
      justifyContent: 'space-around',
    }
  },
  customAppContainer: {
    extend: 'mainSectionContainer'
  },
  customAppText: {
    [theme.breakpoints.up('lg')]: {
      width: 400,
      marginTop: theme.spacing.unit * 10
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing.unit * 5
    }
  },
  customAppTextTitle: {
    font: '300 30px/35px "Open Sans"',
    marginBottom: theme.spacing.unit * 2
  },
  customAppTextDescription: {
    font: '300 17px/21px "Open Sans"'
  },
  customAppImage: {
    position: 'relative',
    zIndex: -1,
    overflow: 'hidden'
  },
  customAppImageInner: {
    position: 'relative',
    width: 304,
    height: 599,
    margin: 'auto',
    background: {
      image: `url("${iphoneImage}")`,
      size: 'cover'
    },
    '&:before': {
      width: 250,
      height: 445,
      position: 'absolute',
      top: 73,
      left: 29,
      display: 'block',
      content: '""',
      background: {
        image: `url(${brandedAppImage})`,
        size: 'cover'
      }
    }
  },
  // Footer
  footer: {
    height: 700,
    marginTop: -600,
    display: 'flex',
    alignItems: 'flex-end',
    position: 'relative',
    paddingBottom: theme.spacing.unit * 5,
    background: {
      image: `url('data:image/svg+xml;utf8,${encodeURIComponent(footerStripeSvg)}')`,
      size: 'cover'
    },
    [theme.breakpoints.up('sm')]: {
      backgroundPosition: 'center bottom',
      justifyContent: 'flex-end',
      textAlign: 'right'
    },
    [theme.breakpoints.down('sm')]: {
      backgroundPosition: '60% bottom'
    }
  }
});



// WEBPACK FOOTER //
// ./src/pages/Features/styles.js